import React from 'react';

import leftArrow from '../../../assets/left_arrow.svg';
import rightArrow from '../../../assets/right_arrow.svg';
import './style.css';
interface AddTitleProps {
  headText: any;
  subText: string;
  hasOption: boolean;
  scrollNext: any;
  scrollPrev: any;
}
const HeaderTitle: React.FC<AddTitleProps> = ({
  headText,
  subText,
  hasOption,
  scrollPrev,
  scrollNext
}) => {
  return (
    <div className="HeaderTitle">
      <div>
        <div className="HeaderText">{headText}</div>
        <div className="headSubTitle">{subText}</div>
      </div>
      {hasOption ? (
        <div>
          <img
            src={leftArrow}
            alt="navigation"
            width="30px"
            height="30px"
            onClick={scrollPrev}
            style={{cursor: 'pointer'}}
          />
          <img
            src={rightArrow}
            alt="navigation"
            width="30px"
            height="30px"
            onClick={scrollNext}
            style={{cursor: 'pointer'}}
          />
        </div>
      ) : null}
    </div>
  );
};

export default HeaderTitle;
